import React from 'react';
import { useSelector } from 'react-redux';
import { useWindowSize } from '@yme/common/hooks';
import { MegaMenuColStyled, MegamenuListItemStyled, MegamenuStyled, } from '@yme/components/Header/styled';
import { Link } from '@yme/components/Link';
import { useTouchOnly } from '@yme/hooks/useTouchOnly';
import { getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { MegaMenuList } from './MegaMenuList';
import { getCMPlProductLink } from './helpers';
export function MenuWithLists({ navItems, buttonLabel, closeMenuHandler }) {
    const isRightToLeft = useSelector(getRTL);
    const { isInfiniteDesktopView } = useWindowSize();
    const isTouchDevice = useTouchOnly();
    const onClickHandler = (cb) => () => {
        closeMenuHandler();
        cb();
    };
    return (React.createElement(MegamenuStyled, { isRightToLeft: isRightToLeft },
        React.createElement(FlexWrapper, { justifyContent: "flex-start", flexWrap: !isInfiniteDesktopView ? 'wrap' : undefined, height: "100%", paddingDesktop: `${INDENT.sm} 0 ${INDENT.xs}`, paddingTablet: `${INDENT.xs} ${INDENT.sm} 0`, paddingMobile: `${INDENT.xs} ${INDENT.xs} 0` }, navItems.map(({ title, link, filters, onClick, isMenuStandoutColourEnabled }) => (React.createElement(MegaMenuColStyled, { key: title, isRightToLeft: isRightToLeft, isTouchDevice: isTouchDevice },
            React.createElement(MegaMenuList, { listTitle: title, menuLink: link, isMenuStandoutColourEnabled: isMenuStandoutColourEnabled, buttonLabel: buttonLabel, closeMenuHandler: closeMenuHandler, isWidthAuto: true, isRightToLeft: isRightToLeft }, filters?.map(({ title: filterTitle, filter, isDiscountMode }) => {
                const linkProp = getCMPlProductLink({
                    link,
                    filter,
                    isDiscountMode,
                });
                const onItemClick = () => {
                    onClick(linkProp);
                };
                return (React.createElement(MegamenuListItemStyled, { key: filterTitle, isRightToLeft: isRightToLeft, isLink: true, isSmallItem: true },
                    React.createElement("span", null,
                        React.createElement(Link, { to: linkProp, onClick: onClickHandler(onItemClick) }, filterTitle))));
            }))))))));
}
